import ViewContext from '../Repository/ViewContext';
import IEpiserverContext from '../Core/IEpiserverContext';
import EpiContext from '../Spa';

export default class History {
  private static toSpaPath(newPath: string): string {
    return (EpiContext.config().basePath !== '/' ? EpiContext.config().basePath : '') + newPath;
  }

  public static pushPath(newPath: string) {
    if (window.history && window.history.pushState) {
      const spaPath = this.toSpaPath(newPath);
      console.debug(`[History] window.history.pushState ${spaPath}`);
      window.history.pushState({}, '', spaPath);
    }
  }

  public static replacePath(newPath: string) {
    if (window.history && window.history.replaceState) {
      const spaPath = this.toSpaPath(newPath);
      console.debug(`[History] window.history.replaceState ${spaPath}`);
      window.history.replaceState({}, '', spaPath);
    }
  }
}
